import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAssignment = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8 4L9.3 2.375C9.49 2.138 9.777 2 10.081 2H13.92C14.224 2 14.511 2.138 14.701 2.375L16 4M8 4V5C8 5.552 8.448 6 9 6H15C15.552 6 16 5.552 16 5V4M8 4H6C4.895 4 4 4.895 4 6V19C4 20.105 4.895 21 6 21H18C19.105 21 20 20.105 20 19V6C20 4.895 19.105 4 18 4H16M8 11H16M8 16H16",
		stroke: "#111827",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgAssignment);
export default ForwardRef;
